import React from "react";
import Header from "../nav/Header";
import { Link } from "react-router-dom";
import Mamakit from "../pages/media/mamakit.png";
import GuideImg from "../pages/media/guides.png";
import FacilityImg from "../pages/media/facilities.png";
import VideosImg from "../pages/media/videos.png";
import KitsImg from "../pages/media/kits.png";
import MedicsImg from "../pages/media/medics.png";

function Landing() {
  return (
    <React.Fragment>
      <Header />
      <div className="container mt-5">
        <div className="row">
          <div className="col-12">
            <h1 className="welcome mb-0">Welcome to Sarai React</h1>
            <h2 className="sub-header mt-0">
              Find everything you need to learn about pregnancy, childbirth and
              motherhood.
            </h2>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-6 text-right">
            <img src={Mamakit} alt="kendoka" width="550px" />
          </div>
          <div className="col-6 components-list">
            <div className="mb-3">
              <img src={GuideImg} alt="components" width="50px" />
              <Link to="/guides"> Read our Guides</Link>
            </div>
            <div className="mb-3">
              <img src={VideosImg} alt="components" width="50px" />
              <Link to="/videos"> Find useful maternity Videos</Link>
            </div>
            <div className="mb-3">
              <img src={KitsImg} alt="components" width="50px" />
              <Link to="/kits"> Order our Kits</Link>
            </div>
            <div className="mb-3">
              <img src={FacilityImg} alt="components" width="50px" />
              <Link to="/facilities">
                {" "}
                Find Hospitals, Bloodbanks, Pharmacies and Labs
              </Link>
            </div>
            <div className="mb-3">
              <img src={MedicsImg} alt="components" width="50px" />
              <Link to="/medics"> Find Doctors, Nurses and Midwives</Link>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Landing;
